import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';



const container = document.getElementById('root');
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <HelmetProvider>
      <Router> 
        <App />
      </Router>
    </HelmetProvider>
  );
} else {
  const root = createRoot(container);
  root.render(
    <HelmetProvider>
      <Router> 
        <App />
      </Router>
    </HelmetProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
